import { render } from "./UiDivider.vue?vue&type=template&id=5487820a&ts=true"
import script from "./UiDivider.vue?vue&type=script&lang=ts"
export * from "./UiDivider.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__